module.exports = {"ru":{"modules":{"notifications":{"title":"Уведомления","list":{"empty":"У вас пока не было ни одного уведомления"}}}}}